<template>
  <div>
      <modal 
      name="addVerifierModal" 
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="700px"
      height="auto">
      <div class="v-modal">
          <div class="popup-header fromDetailsPage">
              <h2 class="popup-title">{{iscallFromEdit?'Edit Verifier':'Add Verifier'}}</h2>
              <span @click="$modal.hide('addVerifierModal');closeAddVerifierPopUp()">
              <em class="material-icons">close</em>
              </span>
          </div>
          <form  @submit.prevent data-vv-scope="verifierForm">
            <div class="form-container">
              <div class="vx-row">    
                <template v-if="isCallFromBen&&!iscallFromList&&!iscallFromEdit">
                  <div class="vx-col pb-5" @keyup="formerrors.msg=''" @click="formerrors.msg=''"  >
                      <div class="custom-radio custom-radio_btns" >  
                      <vs-radio class="mr-6" vs-name="selectProcess" @input="updateTempUser(true)" :vs-value="true" v-model="tempUser">Create Account for Verifier</vs-radio>
                      <vs-radio  vs-name="selectProcess" @input="updateTempUser(false)" :vs-value="false" v-model="tempUser">Continue without Account</vs-radio>
                      <input type="hidden" :name="'select_Process'" :key="'select_Process'" v-validate="'required'" data-vv-as="Field"  v-model="tempUser">
                      </div> 
                  </div>
                </template>
                </div>
                      <div class="vx-row" @keyup="formerrors.msg=''" @click="formerrors.msg=''" >  
                              <immiInput :wrapclass="'md:w-1/2'" formscope="verifierForm" :cid="'benf'" v-model="VerifierDetails.firstName"  :display="false" :tplkey="'firstName'" :tplsection="''"   :required="true" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                              <immiInput :wrapclass="'md:w-1/2'" formscope="verifierForm" :cid="'benm'" v-model="VerifierDetails.lastName" :display="false" :tplkey="'lastName'" :tplsection="''"   :required="true" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                              <immiInput :wrapclass="'md:w-1/2'"  :display="false"  v-model="VerifierDetails.email"  :tplkey="'email'" datatype="email" cid="benfemail" formscope="verifierForm"  :required="true" :tplsection="''"  :fieldName="'email'"  label="Email" placeHolder="Email" />
                              <immiPhone :wrapclass="'md:w-1/2 phonenumber_sm'"  :fieldsArray="[]" :display="true" :tplkey="''" @updatephoneCountryCode="updatePhoneCountryCode" :countrycode="VerifierDetails.phoneCountryCode.countryCode" cid="bencellPhoneNumber" formscope="verifierForm" v-model="VerifierDetails.phone" :tplsection="''"  :fieldName="'cellPhoneNumber'" :required="true" label="Phone Number" placeHolder="Phone Number" />
                      </div>
                      <div class="vx-col w-full">
                        <div >
                            <h3 class="small-header"> Address</h3>
                            <addressFields :disableCountryWithUS="true" :wrapclass="'pad0'" v-if="countries.length > 0"  :prefiilAddress="false" :hideusa="false" :validationRequired="false" :disableCountry="true" :formscope="'verifierForm'" :showaptType="true" :addFormContainerCls="true" :countries="countries"  v-model="VerifierDetails.address" fieldName="chi_addressOutsideUS" :cid="'chi_addressOutsideUS'" />

                        </div>
                    </div>
            </div>
            <div class="popup-footer relative">
              <figure v-if="submitForm" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
            <vs-button color="dark" @click="closeAddVerifierPopUp();submitForm=false" class="cancel" type="filled">Cancel</vs-button>
            <vs-button color="success" :disabled="submitForm" @click="saveVerifier" class="save" type="filled">Submit</vs-button>
            </div>
        </form>
      </div>
      </modal>
  </div>
</template>

   <script>
     import immiInput from "@/views/forms/fields/simpleinput.vue";
     import immiPhone from "@/views/forms/fields/phonenumber.vue";
     import addressFields from "@/views/forms/fields/address.vue"; 
   
     export default {
         components:{
             immiInput,
             immiPhone,
             addressFields,
         },
         provide() {
             return {
                 parentValidator: this.$validator,
             };
         },
         data(){
           return{
            tempUser:true,
             formerrors: {
                 msg: ""
             },
             countries: [],
             submitForm:false,
             VerifierDetails:{
                "firstName": "",
                "middleName": "",
                "lastName": "",
                "name": "",
                "email": "",
                "phone": "",
                "phoneCountryCode": {
                    "countryCode": "",
                    "countryCallingCode": ""
                },
                "roleId": 49,
            "address": {
                "line1": "",
                "line2": "",
                "aptType": '',
                "locationId": 0,
                "stateId": 0,
                "countryId": null,
                "zipcode": "",
                "locationDetails": null,
                "stateDetails": null,
                "countryDetails": null,
             },
                "checkDeleteOrInactive": true
            },
           }
         },
         methods:{
          getUserDetails(){
            let postData = { userId: "" };
            postData['userId'] = this.selectedUser['_id']
            this.$store.dispatch("commonAction", { "data": postData, "path": "/users/details" }).then((response) => {
             if(response&&response.details){
              this.VerifierDetails = response.details
             }else{
              this.VerifierDetails = this.selectedUser
             }
            });
          }, 
          updateTempUser(action){
            this.tempUser = action
          },
            closeAddVerifierPopUp(data = null){
             this.$emit('closeAddVerifierPopUp', data)
             this.$modal.hide('addVerifierModal');
           },
           updatePhoneCountryCode(data){
             this.VerifierDetails.phoneCountryCode =data;  
           },
           saveVerifier() {
           this.$validator.validateAll('verifierForm').then(result => {
             if(result){
              let firstname = this.VerifierDetails['firstName'].trim();
                let lastname = this.VerifierDetails['lastName'].trim();
                this.VerifierDetails = Object.assign(this.VerifierDetails, { name: firstname + ' ' + lastname });
                this.VerifierDetails = Object.assign(this.VerifierDetails, { "firstName": firstname });
                this.VerifierDetails = Object.assign(this.VerifierDetails, { "lastName": lastname });
                // this.VerifierDetails['accountUserType']= this.tempUser ;
                this.VerifierDetails['tempUser'] = this.isCallFromBen? this.tempUser : false
                this.tempUser =  this.VerifierDetails['tempUser']
                // this.VerifierDetails['tempUser'] = this.isCallFromBen? this.tempUser : false

                let path;
                if(this.tempUser){
                  if(this.iscallFromEdit){//roleId
                    path =  "/users/update"
                    this.VerifierDetails = Object.assign(this.VerifierDetails, { "userId": this.checkProperty(this.selectedUser, '_id') });
                  }else{
                    path =  "/users/register"
                  }
                }else{
                  path = "/i9/create-verifier-without-account"
                  this.VerifierDetails = Object.assign(this.VerifierDetails, { "i9Id": this.checkProperty(this.caseDetails, '_id') });
                }
                // let path = this.tempUser ? "/users/register" : "/i9/create-verifier-without-account"

                let postData =this.VerifierDetails ;
                this.submitForm=true
               this.$store
                 .dispatch("commonAction", {"data":postData ,"path":path})
                 .then(response => {
                    this.showToster({message:response.message,isError:false });
                   this.submitForm =false;
                   let obj= {
                      "_id":this.checkProperty(response, '_id'),
                      "customId": this.checkProperty(response, 'customId'),
                      "firstName": this.checkProperty(response, 'firstName'),
                      "middleName": this.checkProperty(response, 'middleName'),
                      "lastName": this.checkProperty(response, 'lastName'),
                      "name": this.checkProperty(response, 'name'),
                      "email": this.checkProperty(response, 'email'),
                      "alreadyExisted": this.checkProperty(response, 'alreadyExisted'),
                      "phone": this.checkProperty(response, 'phone'),
                      "phoneCountryCode": this.checkProperty(response, 'phoneCountryCode'),
                      "tempUser":this.checkProperty(response, "tempUser")
                    }   

                  this.closeAddVerifierPopUp(obj)
                  this.$modal.hide('addVerifierModal');
                 })
                 .catch((error)=>{
                  this.showToster({message:error,isError:true });
                   this.submitForm =false;
                   Object.assign(this.formerrors, {
                       msg:error
                     });
                 })
             }
           });
         },
         
   
         },
         props:{
          caseDetails:null,
          isCallFromBen:{
            type:Boolean,
            default:true
          },
          iscallFromList:{
            type:Boolean,
            default:false
          },
          iscallFromEdit:{
            type:Boolean,
            default:false
          },
          selectedUser:{
            default:null
          }
          },
         mounted(){
           this.$store.dispatch("getcountries").then((response) => {
              this.countries = response;
            });
            this.$modal.show('addVerifierModal');
            if(this.iscallFromEdit){
              this.getUserDetails()
            }
         }
     }
   
   
   </script>